import React, { FC } from "react";

import { PostPaymentStep, PostPaymentStepProps } from "../../components/setup/PostPayment";

import { ClientApp } from "models";

export interface PostPaymentStepContainerProps extends Omit<PostPaymentStepProps, "onNext"> {
    app?: ClientApp;
    onNext(): void;
}

export const PostPaymentStepContainer: FC<PostPaymentStepContainerProps> = (props) => {
    const { app, onNext, ...restProps } = props;

    // Analytics tracking (commented out for now)
    /*
    useEffect(() => {
        // Track post-payment step view
        ReactGA.event("setup_step_view", {
            step: "post_payment",
        });
    }, []);
    */

    const handleNext = () => {
        // No additional processing needed for this step
        // Nothing to save, just continue.
        onNext();
    };

    return <PostPaymentStep {...restProps} app={app} onNext={handleNext} />;
};
